export default __webpack_public_path__ + "static/media/Gilroy-Bold.ef7c40ff.woff2";